import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Container = styled.div(() =>
  mq({
    position: ['static', 'static', 'static', 'static', 'sticky'],
    top: '10px',
    width: ['100%', '100%', '100%', '100%', '300px'],
    height: 'max-content',
    backgroundColor: defaultTheme.background.white,
    borderRadius: [0, 0, 0, 0, defaultTheme.border.radius.l],
    boxShadow: [
      'initial',
      'initial',
      'initial',
      'initial',
      `0px 0px 8px ${defaultTheme.color.grayScale.medium}`,
    ],
    padding: [0, 0, 0, 0, defaultTheme.spacing.xxl],
    marginTop: [
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      0,
    ],
  }),
);

export const ButtonWrapper = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateRows: 'repeat(auto-fill, 56px)',
    gridGap: `${defaultTheme.spacing.xxl} 0`,
    width: ['100%', '100%', '100%', '100%', '242px'],
    padding: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      0,
    ],
  }),
);
